import * as React from 'react';

import { RootLayout } from './src/utils/RootLayout';

export const wrapRootElement = ({ element }) => (
  <RootLayout>{element}</RootLayout>
);

// Gatsby resolves the rewritten page to /data/ after hydration. Keep the
// public URL at the dedicated subdomain root, preserving language and hash.
export const onRouteUpdate = () => {
  if (window.location.hostname === 'datos.bcharg.com' &&
      /^\/data\/?$/.test(window.location.pathname)) {
    window.history.replaceState(window.history.state, '', '/' + window.location.search + window.location.hash);
  }
};
